import React from 'react';
import moment from "moment";
import { Link } from 'react-router';
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import EditButton from "../base/EditButton";
import { translate } from '../base/Translation';

export default class ErrorDBList extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_error_dbs: "/error_db/fetch/all?limit_from=:from&limit_max=:to&brand=:brand",
			delete_error_db: "/error_db/delete/:error_db"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			error_dbs: [],
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Názov"), sort: true, width: 31 },
				{ name: "error_count", display: translate("Počet chýb"), sort: true, width: 10 },
				{ name: "weaves", display: translate("Vlny"), sort: true, width: 34 },
				{ name: "date_created", display: translate("Vytvorené"), sort: true, width: 9 },
				{ name: "date_updated", display: translate("Upravené"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 7 }
			]
		};
	}

	componentDidMount() {
		this.fetchData();
	}

	convertDataForTable(data) {
		return data.map(function (error_db) {
			let data = {};
			data.id = error_db.id;
			data.name = <Link to={"/error_dbs/" + error_db.id}>{error_db.name}</Link>;
			data.error_count = error_db.error_count;
			data.weaves = error_db.weaves.map(function (weave, index, weaves) {
				return (
					<span key={"weave_" + weave.id + "_" + weave.name}>{weave.name + (index !== (weaves.length - 1) ? ", " : "")}</span>
				)
			});
			data.date_created = moment(error_db.created.date).format("D.M.Y");
			data.date_updated = moment(error_db.updated.date).format("D.M.Y");
			data.options = (
				<div style={{textAlign: "right"}}>
					<EditButton to={"/error_dbs/edit/" + error_db.id} className="btn btn-xs btn-primary" permission="ErrorDBEdit" />
					<DeleteButton onClick={this.onDelete.bind({ error_db: error_db.id, currentComponent: this })} permission={"ErrorDBNew"} />
				</div>
			)
			return data;
		}.bind(this));
	}

	fetchData() {
		let brandFilter = Storage.get("brand_filter");

		this.api.request({
			cache: true,
			route: "get_error_dbs",
			params: { from: this.state.limit_from, to: this.state.limit_to, brand: (brandFilter ? brandFilter.id : "all") },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ error_dbs: response, tableData });
			}
		});
	}

	onDelete(evt) {
		this.currentComponent.api.request({
			route: "delete_error_db",
			params: { "error_db": this.error_db },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});

	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns} data={this.state.tableData} headers={true} searchBy="name" title={translate("Databázy chýb")} right={() => {
				if (Storage.get("allowed_components").indexOf("ErrorDBNew") === -1) {
					return "";
				}
				return (
					<Link to="/error_dbs/add/new" className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
				)
			}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/error_db/ErrorDBList.js